import React from 'react';
import styles from './CTAButton.module.scss';

interface CTAButtonProps {
    variant?: 'primary' | 'secondary' | 'outline' | 'hero';
    size?: 'sm' | 'md' | 'lg';
    children: React.ReactNode;
    onClick?: () => void;
    href?: string;
    target?: string;
    className?: string;
    disabled?: boolean;
    icon?: React.ReactNode;
    iconPosition?: 'left' | 'right';
}

const CTAButton: React.FC<CTAButtonProps> = ({
    variant = 'primary',
    size = 'md',
    children,
    onClick,
    href,
    target,
    className = '',
    disabled = false,
    icon,
    iconPosition = 'right',
}) => {
    const buttonClasses = `
        ${styles.cta_button}
        ${styles[`cta_button--${variant}`]}
        ${styles[`cta_button--${size}`]}
        ${className}
    `.trim();

    const content = (
        <>
            {icon && iconPosition === 'left' && <span className={styles.icon}>{icon}</span>}
            <span className={styles.text}>{children}</span>
            {icon && iconPosition === 'right' && <span className={styles.icon}>{icon}</span>}
        </>
    );

    if (href) {
        return (
            <a href={href} target={target} className={buttonClasses} onClick={onClick}>
                {content}
            </a>
        );
    }

    return (
        <button className={buttonClasses} onClick={onClick} disabled={disabled}>
            {content}
        </button>
    );
};

export default CTAButton;
